import { apiGet, apiPost } from '../js/api';
import Server from '../js/config/_server';
import { RESPONSE } from '../js/_constants';
import type { DistributedMedium, PlaylistIri, Playlist } from './types/index';
import type { ResourceResponse, CollectionResponse } from './types/response';

/**
 * @param {string} sortBy Sorting options
 * @returns Promise
 */

export const createPlaylist = options => {
    const url = Server.baseUrl + Server.services.playlists.create;
    return apiPost(url, options);
};

export const getPlaylists = () => {
    const url = Server.baseUrl + Server.services.playlists.userPlaylists;
    return apiGet(url);
};

/**
 * @param {string} countryIso3
 * @returns Promise
 */
export const getFallbackPlaylist = (countryIso3: string) => {
    const url = `${Server.baseUrl}${Server.services.playlists.fallbacks}?fallbackCountries=${countryIso3}`;
    return apiGet<CollectionResponse<Playlist>>(url);
};

export const getGlobalFallbackPlaylist = () => {
    const url = `${Server.baseUrl}${Server.services.playlists.fallbacks}?globalFallback=true`;
    return apiGet<CollectionResponse<Playlist>>(url);
};

export const addManyItemsToPlaylist = (
    playlistIri: PlaylistIri,
    mediaItems: DistributedMedium[]
) => {
    const postItemsUrl = `${Server.baseUrl}${playlistIri}/items`;
    return Promise.all(
        mediaItems.map((item, index) => {
            const options = {
                body: {
                    medium: item[RESPONSE.ID],
                    position: index + 1,
                    duration:
                        item['@type'] === 'Image' ? 15 : (item.duration as number)
                }
            };
            return apiPost<ResourceResponse<Playlist>>(postItemsUrl, options);
        })
    );
};
